import { EDrawingActionType } from './types';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export const startDrawing = actionGenerator<EDrawingActionType.DrawingStarted>(EDrawingActionType.DrawingStarted);
